<template>
    <div>
      <Head title="Purchase Order Pending Approval" />
      <h1 class="mb-8 text-3xl font-bold">Purchase Orders Pending Approval</h1>
      <div class="flex items-center justify-between mb-6 mt-6">
        <search-filter v-model="search.search" class="mr-4 w-full max-w-md" @reset="reset">
          <label class="block text-gray-700">Purchase Order Pending Approval:</label>
        </search-filter>
      </div>
      <div class="bg-white rounded-md shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <tr class="text-left font-bold">
            <th class="pb-3 pt-3 px-3">Supplier Name</th>
            <th class="pb-3 pt-3 px-3">Type</th>
            <th class="pb-3 pt-3 px-3">Account</th>
            <th class="pb-3 pt-3 px-3">PO Number</th>
            <th class="pb-3 pt-3 px-3">VAT</th>
            <th class="pb-3 pt-3 px-3">Planned Date</th>
            <th class="pb-3 pt-3 px-3">Status</th>
          </tr>
          <tr v-for="purchaseOrder in purchaseOrders.data" :key="purchaseOrder.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
            <td class="border-t">
              <span class="flex items-center px-3 py-3" @click="openModal(purchaseOrder)" tabindex="-1">
                {{ purchaseOrder.name }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-3 py-3" @click="openModal(purchaseOrder)" tabindex="-1">
                {{ purchaseOrder.type }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-3 py-3" @click="openModal(purchaseOrder)" tabindex="-1">
                {{ purchaseOrder.account }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-3 py-3" @click="openModal(purchaseOrder)" tabindex="-1">
                {{ purchaseOrder.PO_number }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-3 py-3" @click="openModal(purchaseOrder)" tabindex="-1">
                {{ purchaseOrder.has_vat }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-3 py-3" @click="openModal(purchaseOrder)" tabindex="-1">
                {{ purchaseOrder.planned_date }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-3 py-3" @click="openModal(purchaseOrder)"  tabindex="-1">
                {{ purchaseOrder.status }}
              </span>
            </td>
          </tr>
          <tr v-if="purchaseOrders.data.length === 0">
            <td class="px-3 py-3 border-t" colspan="4">No data found</td>
          </tr>
        </table>
      </div>
      <pagination class="mt-6" :links="purchaseOrders.links" />
    </div>
    <div v-if="isOpen" class="fixed z-10 inset-0 overflow-y-auto">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div class="fixed inset-0 transition-opacity">
          <div class="absolute inset-0 bg-gray-500 opacity-75" />
        </div>
        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
        <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <form>
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full">
                <h1>
                  <strong>{{ PO.type }}: {{ PO.name }}, Account {{ PO.account }}</strong>
                </h1>
              </div>
              <div class="flex w-full mt-4 overflow-x-auto">
                <table class="w-full border-collapse border border-gray-700 border-slate-700">
                  <thead>
                    <tr>
                      <th class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700">
                        PO No.
                      </th>
                      <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                        Document Date
                      </th>
                      <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                        Payment Method
                      </th>
                      <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                        Delivery Terms
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700">{{ PO.PO_number }}</td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700">{{ PO.created_on }}</td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="w-full overflow-x-auto">
                <table class="w-full border-collapse border border-gray-700 border-slate-700">
                  <thead>
                    <tr>
                      <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                        Item No.
                      </th>
                      <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                        Goods/services offered
                      </th>
                      <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                        Description
                      </th>
                      <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                        Quantity
                      </th>
                      <th class="px-1 py-2 text-sm border border-gray-700 border-slate-7000">
                        Units
                      </th>
                      <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                        Purchase Price({{ PO.currency }})
                      </th>
                      <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                        Subtotal
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr  v-for="(orderedProduct, index) in PO.orderedProducts" :key="orderedProduct.id">
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700">
                        {{ index + 1 }}
                      </td>
                      <td class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                        {{ orderedProduct.part_number }}: {{ orderedProduct.goods_service_offered }}
                      </td>
                      <td class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                        {{ orderedProduct.description }}
                      </td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700 text-right">
                        {{ orderedProduct.quantity }}
                      </td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700">
                        {{ orderedProduct.unit_of_measure }}
                      </td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700 text-right">
                        {{ orderedProduct.unit_price }}
                      </td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700 text-right">
                        {{ orderedProduct.total }}
                      </td>
                    </tr>
                    <tr
                      v-for="val in [1,2,3,4,5,6,7,8]"
                      :key="`d-${val}`">
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                    </tr>
                    <tr v-show="has_vat == 'yes'">
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700" colspan="3">
                        SUBTOTAL
                      </td>
                      <td class="px-1 py-2 text-sm border border-gray-700 border-slate-700">{{ PO.currency }}. <span class="text-right">{{ PO.overal_total }}</span></td>
                    </tr>
                    <tr v-show="has_vat == 'no'">
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700" colspan="3">
                        SUBTOTAL
                      </td>
                      <td class="px-1 py-2 text-sm border border-gray-700 border-slate-700">{{ PO.currency }}. <span class="text-right">{{ PO.overal_total }}</span></td>
                    </tr>
                    <tr v-show="PO.has_vat == 'yes'">
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700" colspan="3">
                        VAT({{ PO.vat }}%)
                      </td>
                      <td class="px-1 py-2 text-sm border border-gray-700 border-slate-700">{{ PO.currency }}. <span class="text-right">{{ PO.vat_total }}</span></td>
                    </tr>
                    <tr>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                      <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700 font-bold" colspan="3">
                        TOTAL
                      </td>
                      <td class="px-1 py-2 text-sm border border-gray-700 border-slate-700 font-bold">{{ PO.currency }}. <b class="text-right">{{ PO.overal_total_plus_vat }}</b></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">            
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button @click="closeModal" type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5">
                Cancel
              </button>
            </span>
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" @click="confirm(10, 'Declined')" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red sm:text-sm sm:leading-5">
                Decline
              </button>
            </span>
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" @click="confirm(0, 'Placed')" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green sm:text-sm sm:leading-5">
                Approve
              </button>
            </span>            
          </div>
          </form>
        </div>
      </div>
    </div>
    <div class="fixed z-10 inset-0 overflow-y-auto" v-if="isConfirmOpen">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div class="fixed inset-0 transition-opacity">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
        <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <form>
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div class="mb-4">
                <p>
                    You are about to update the purchase order <strong>{{ PO_number }}</strong> status to <strong>{{ status_label }}</strong>.
                    Do you wish to continue?
                </p>
              </div>
            </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">            
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button @click="closeConfirmModal" type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5">
                Cancel
              </button>
            </span>
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" @click="approval()" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-orange-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm sm:leading-5">
                Save
              </button>
            </span>            
          </div>
          </form>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue3'
  import Icon from '@/Shared/Icon'
  import pickBy from 'lodash/pickBy'
  import Layout from '@/Shared/Layout'
  import throttle from 'lodash/throttle'
  import mapValues from 'lodash/mapValues'
  import SearchFilter from '@/Shared/SearchFilter'
  import Pagination from '@/Shared/Pagination'
  
  export default {
    components: {
      Head,
      Link,
      Icon,
      SearchFilter,
      Pagination,
    },
    layout: Layout,
    props: {
      filters: Object,
      purchaseOrders: Object,
    },
    data() {
      return {
        isOpen: false,
        search: {
          search: this.filters.search,
        },
        PO_number: null,
        id: null,
        PO: null,
        isConfirmOpen: false,
      }
    },
    watch: {
      search: {
        deep: true,
        handler: throttle(function () {
          this.$inertia.get('/purchase-orders/pending-approval', pickBy(this.search), {
            preserveState: true,
            preserveScroll: true,
            replace: true
          })
        }, 150),
      },
    },
    methods: {
      reset() {
        this.search = mapValues(this.search, () => null)
      },
      openModal(data) {
        this.PO_number = data.PO_number;
        this.PO = data;
        this.isOpen = true;
        this.isConfirmOpen = false
      },
      confirm(value, label) {
        this.PO_number = this.PO.PO_number;
        this.id = this.PO.id;
        this.status = value;
        this.status_label = label;
        this.isConfirmOpen = true
      },
      closeModal() {
        this.PO_number = null;
        this.isOpen = false;
        this.isConfirmOpen = false
      },
      closeConfirmModal() {
        this.PO_number = null;
        this.isOpen = true;
        this.isConfirmOpen = false
      },
      approval() {
        const data = {};
        data.id = this.id;
        data.status = this.status;
        data._method = 'POST';
        this.$inertia.post(`/purchase-orders/pending-approval/${data.id}`, data)
        this.PO_number = null;
        this.id = null;
        this.status = null;
        this.status_label = null;
        this.PO = null
        this.closeModal();
      },
    },
  }
  </script>
  